require("core-js/features/array/find");

import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IContractSettings } from "../../new-contract-vuex-store";
import FormGroupStatic from "../phases/form-group-static.vue";
import ContractPartnerCard from "./components/contract-partner-card.vue";
import { IMeteringPointViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, InvoicingMethodEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { AddressFormat } from "../../../../../Scripts/inpulse/AddressFormat";
import { GenericTypeFormatTranslator, InvoicingMethodFormat } from "../../../../../Scripts/inpulse/FormatUtils";
import { TranslateResult } from "vue-i18n";
import * as moment from "moment-recent";

@Component({
    components: {
        FormGroupStatic,
        ContractPartnerCard
    },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    }
})

export default class MoveOutMeteringPointInformationDisplay extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get meteringPoint(): IMeteringPointViewModel { return this.contract.MeteringPoint; }
    get isInvoicingMethodsInUse(): boolean { return this.contractSettings.InvoicingMethodsInUse; }

    AddressFormat: typeof AddressFormat = AddressFormat;
    InvoicingMethodEnum: typeof InvoicingMethodEnum = InvoicingMethodEnum;

    get addressString(): string {
        return AddressFormat.toSingleString(this.meteringPoint.Address);
    }

    get customerAddressString(): string {
        return this.contract.CustomerType == CustomerTypeEnum.COMPANY ? AddressFormat.toSingleString(this.contract.Company.Address) : AddressFormat.toSingleString(this.contract.Customer.Address);
    }

    invoicingTypeString(type: InvoicingMethodEnum): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(InvoicingMethodFormat.toString, type, this.$i18n);
    }

    join(separator: string, strs: string[]) {
        const arr = [];
        strs.forEach(s => {
            if (s != null && s.length != 0)
                arr.push(s);
        });
        return arr.join(separator);
    }

    formatPostal(postalCode: string, postOffice: string) {
        const str = this.join(", ", [postalCode, postOffice]);
        return str;
    }
}